module.exports = __webpack_public_path__ + "img/second-title.00f79bd7.png";